import PasswordRestoration from '@/views/Password/Restoration/index.vue';
import PasswordChange from '@/views/Password/Change/index.vue';
import PasswordSuccess from '@/views/Password/Success/index.vue';

export default [
  {
    path: '/password/restoration',
    name: 'PasswordRestoration',
    component: PasswordRestoration,
    meta: {
      titleType: 'restorePassword',
    },
  },

  {
    path: '/password/change',
    name: 'PasswordChange',
    component: PasswordChange,
    meta: {
      titleType: 'restorePassword',
    },
  },

  {
    path: '/password/success',
    name: 'PasswordSuccess',
    component: PasswordSuccess,
    meta: {
      titleType: 'restorePassword',
    },
  },
];
